import React from "react";
import LoadingOverlay from "react-loading-overlay-ts";

const SpinnerOverlay = ({ showLoader, children }) => (
  <LoadingOverlay
    active={showLoader}
    spinner
    styles={{
      overlay: (base) => ({
        ...base,
        background: "#FCFCFC",
        opacity: 0.5,
        zIndex: 2147483647, // max possible value
      }),
      spinner: (base) => ({
        ...base,
        width: "100px",
        "& svg circle": {
          stroke: "#83c3f6",
          strokeWidth: 3,
        },
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }),
    }}
  >
    {children}
  </LoadingOverlay>
);

export default SpinnerOverlay;
